import React from 'react';
import TradePositionChoice from './TradePositionChoice';

const PositionChoice = ({ dataPosition, onClosePosition, sendPositionData, value, runChat, organizerName, showDelIcon, showCheckIcon, showAddBtn, asCustomer, lotNum}) => {

    const doEmpty = () => {

    }

    const handleRunChat = (text, recipient) => {
        runChat(text, recipient)
    }

    // console.log(lotNum);
    return (
        <>
            <TradePositionChoice
                show={true}
                nameTrade={dataPosition.nameTrade}
                dataTech={dataPosition.tech}
                dataCommerce={dataPosition.commercial}
                showTech={true}
                showCommercial={true}
                serverData={dataPosition}
                keyNameTrade={dataPosition.keyNameTrade}
                organizerId={dataPosition.organizerId}
                priority={dataPosition.priority}
                fileId={dataPosition.idFile}
                fileList={dataPosition.fileList}
                archive={dataPosition.archive}
                createDate={dataPosition.createDate}
                onChangeShowTrade={onClosePosition} // команда на закрытие компонента
                readFromServerData={doEmpty} // указывает, что создает новый файл торговой позиции, возвращает ID новой позиции
                openPositionModal={doEmpty}
                sendPositionData={sendPositionData}
                value={value}
                runChat={handleRunChat}
                organizerName={organizerName}
                showDelIcon={showDelIcon}
                showCheckIcon={showCheckIcon}
                showAddBtn={showAddBtn}
                asCustomer={asCustomer}
                lotNum={lotNum}
                // disableParticipantData={false}
            />
        </>
    )
}

export default PositionChoice;